mutation DeleteTickerBar($tickerBarId: ID!) {
  result: StreamToolsDeleteTickerBar(tickerBarId: $tickerBarId) {
    id
    deleted
  }
}
